import { Component, Input, OnInit } from '@angular/core';
import { ExportStatus, MetricEarlierExports, MetricsFacade } from '@app/shared/+state/metrics';
import { LoadingState, User, combineLoadingStates } from '@app/shared/interfaces';
import { PaginationMeta } from '@app/shared/interfaces/lib/api.interface';
import { BadgeSize, BadgeType } from '@app/ui/badge-mono/badge.component.interface';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: `hospitable-metrics-exports`,
  templateUrl: './exports.component.html',
  styleUrls: ['./exports.component.scss', './exports.component.mobile.scss'],
})
export class ExportsComponent implements OnInit {
  @Input() user: User | null;

  pageLoadingState$: Observable<LoadingState | null>;
  LoadingState = LoadingState;
  BadgeType = BadgeType;
  BadgeSize = BadgeSize;
  ExportStatus = ExportStatus;
  exports$: Observable<MetricEarlierExports[] | null>;
  pagination$: Observable<PaginationMeta | null>;

  constructor(private metricsFacade: MetricsFacade) {}

  ngOnInit(): void {
    this.pageLoadingState$ = combineLatest(this.metricsFacade.earlierExportsLoadingState$).pipe(
      map(([earlierExportsLoadingState]) => combineLoadingStates([earlierExportsLoadingState]))
    );
    this.exports$ = this.metricsFacade.earlierExports$;
    this.pagination$ = this.metricsFacade.earlierExportsMetaPagination$;
    this.metricsFacade.loadEarlierExports(1);
  }

  onPageChange(page: number) {
    this.metricsFacade.loadEarlierExports(page);
  }

  downloadExport(uuid: string, filename: string) {
    this.metricsFacade.downloadExport(uuid, filename);
  }
}
